
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
// @ is an alias to /src
import HomeNewslistItem from './HomeNewslistItem.vue';
import $ from 'jquery';
import { fetchPostsNews } from '@/services/userService';
import LoadingAnimation from "@/components/loading/LoadingAnimation.vue";

@Component({
  components: {
    HomeNewslistItem,
    LoadingAnimation
  },
})
export default class HomeNewslist extends Vue {
  private name = 'homenewslist';
  private firstItemsLength = 3;
  private list: PostDataNews[] = [];
  private offset: number = 0;
  private length: number|null = 3;
  private totaleItems: number = 0;
  private isOpend = false;
  get showMore() {
    if (this.totaleItems > this.firstItemsLength) {
      return true;
    } else {
      return false;
    }
  }
  @Emit()
  private setList(list: PostDataNews[]) {
    this.list = list;
  }
  @Emit()
  private async getMoreItems() {
    // this.offset = this.firstItemsLength;
    if (this.length && this.length > 0) {
      this.length = null;
      await this.getEntries();
    }
    if (this.isOpend) {
      this.isOpend = false;
    } else {
      this.isOpend = true;
    }
    this.$nextTick(() => {
      if (!this.$refs.list) return;
      const $list: any = $(this.$refs.list);
      if (this.isOpend) {
        $list.find('.item:hidden').stop().slideDown();
      } else {
        $list.find('.item:gt(' + (this.firstItemsLength - 1) + ')').stop().slideUp();
      }
    });
  }
  @Emit()
  private async getEntries() {
    let params: any = {
      offset: this.offset
    }
    if (this.length) {
      params.length = this.length;
    }
    const result = await fetchPostsNews(params)
    .then( (response) => {
      this.totaleItems = Number(response.hits);
      this.setList(response.datas);
      return true;
    })
    .catch( (e) => {
      console.error(e);
      return false;
    });
    return result;
  }
}
